const functionJs = {}

//生成N位随机数
functionJs.mathRandom = function(count) {
  var num = ''; 
  for (var i = 0; i < count; i++) { 
    if(i == 0){ 
      num += Math.floor(Math.random() * 9 + 1); 
    }else{ 
      num += Math.floor(Math.random() * 10); 
    } 
  }

  return num;
}

//生成随机奖品
functionJs.randomPrize = function() { 
  const goods = [
    'Iphone 13',
    'Iphone 12',
    'Huawei P30',
    'ဖိနပ္စင္',
    'လွ်ပ္စစ္အိုး',
    'ပခုံးအိတ္',
    'ဖိနပ္စင္',
    'ထီးေလး',
    'power bank',
    'ပန္ကာ',
    'ေနေရာင္ျခည္အလင္း',
    'ေက်ာပိုးအိတ္',
    'Bluetooth Speaker',
    'body fat scale',
    'power bank'
  ]
  const phoneBill = [
    'ဖုန္းေဘ5000','ဖုန္းေဘ10000','ဖုန္းေဘ20000','ဖုန္းေဘ30000','ဖုန္းေဘ50000','ဖုန္းေဘ100000'
  ]

  var prize = '';
  const chance = Math.floor(Math.random() * 10);
  if(chance < 3){
    prize = goods[Math.floor(Math.random() * goods.length)]
  }else{
    prize = phoneBill[Math.floor(Math.random() * phoneBill.length)]
  }
  return prize;
}

//生成最近2天的递增日期
functionJs.randomDate = function(num) {
  var timestamp = Date.parse(new Date());
  var interval = (num*num*2 + 60*10*num)*2
  var time = timestamp/1000 - 86400*2 + interval
  var newDate = new Date(time*1000)
  var month = newDate.getMonth() + 1
  var day = newDate.getDate()
  if(month < 10){
    month = '0' + month
  }
  if(day < 10){
    day = '0' + day
  }
  return month + '/' + day;
}

export {
  functionJs
}